import { call, put, takeEvery } from 'redux-saga/effects';
import api from '../common/api';
import checkResponse from '../common/checkResponse';
import { CHECK_CERTIFICATE_RESET_REQUEST, checkCertificateResetReceive, loginPreSuccess } from '../actions/actions';

function* handleRequest(action) {

  try {
    const response = yield call(api, action);
    const payload = yield response.json();
    if(!checkResponse(response, payload)) return;

    if( payload.sc === 0 ) {
      yield put(loginPreSuccess(payload));
      yield put(checkCertificateResetReceive(payload));
    }
  } catch(error) {
    console.log("error ==> ",error);

  }
}

const checkCertificateResetSaga = [takeEvery(CHECK_CERTIFICATE_RESET_REQUEST, handleRequest)];
export default checkCertificateResetSaga;